/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import dayjs from 'dayjs';
import CreateModal from 'components/custom/modal/CreateModal';
import InputBox from 'components/custom/forms/InputBox';
import { useFormik } from 'formik';
import useModalManage from 'hooks/custom/useModalManage';
import * as Yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import LabelInput from 'components/custom/forms/LabelInput';
import LabelSelector from 'components/custom/forms/LabelSelector';
import postData from 'services/postData';
import { useAlert } from 'providers/AlertModalProvider';
import apiEndpoints from 'constants/apiEndpoints';
import useManageLocation from 'hooks/custom/useManageLocation';
import LabelDateSelector from 'components/custom/forms/LabelDateSelector';
import DatePicker from 'components/base/DatePicker';
import TimePicker from 'components/base/TimePicker';
import { useState } from 'react';
import { validDate } from 'services/utils';

const CreateHolidays = ({ show, handleClose, handleRefresh }) => {
  const [modalLoading, modalMessage, setModalLoading] = useModalManage();
  const { country, state, city, manageLocation } = useManageLocation();
  const [time, setTime] = useState(null);

  const { showAlert } = useAlert();

  const calculateNoOfDays = (from_date, to_date) => {
    if (from_date && to_date) {
      // Specify the format of the date strings
      const startDate = dayjs(from_date);
      const endDate = dayjs(to_date);

      // Calculate the difference in days
      const difference = endDate.diff(startDate, 'day') + 1; // Include both start and end dates
      return difference;
    }
    return 0;
  };

  const handleCreateHolidays = async values => {
    setModalLoading(true, 'Creating Holidays');
    const no_of_days = calculateNoOfDays(values.from_date, values.to_date);

    const request = await postData(
      { ...values, no_of_days },
      apiEndpoints.holiday.create
    );
    if (request.status) {
      setModalLoading(false);
      showAlert({
        variant: 'info',
        message: `Approval has been successfully raised to create the Holiday ${values.title}.`
      });
      handleRefresh();
      handleClose();
    } else {
      setModalLoading(false);
      showAlert({
        variant: 'danger',
        message: `Failed to create the Holiday ${values.title}.`
      });
    }
  };
  const formik = useFormik({
    initialValues: {
      title: '',
      from_date: '',
      to_date: ''
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required('Please Enter the Title')
        .max(30, 'Title cannot be longer than 30 characters'),
      from_date: Yup.mixed().required('Please Enter From Date'),
      to_date: Yup.mixed().required('Please Enter To date')
    }),

    onSubmit: values => {
      handleCreateHolidays(values);
    }
  });

  const handleLocationChange = (name, value) => {
    manageLocation(formik, name, value);
  };

  return (
    <CreateModal
      show={show}
      loading={modalLoading}
      loadingText={modalMessage}
      handleClose={handleClose}
      heading={'Create Holiday'}
      handleSubmit={formik.handleSubmit}
    >
      <Row className="gy-2 gx-2">
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelInput
              required={true}
              errorProps={{ tooltip: false }}
              label={'Title'}
              controlId={'title'}
              formik={formik}
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelDateSelector
              errorProps={{ tooltip: false }}
              dateOptions={{
                maxDate: '',
                minDate: '',
                datePostFormate: 'YYYY-MM-DD'
              }}
              controlId={'from_date'}
              label={'From Date'}
              formik={formik}
              required
            />
          </InputBox>
        </Col>
        <Col xs={12} sm={12}>
          <InputBox>
            <LabelDateSelector
              errorProps={{ tooltip: false }}
              dateOptions={{
                maxDate: '',
                minDate: '',
                datePostFormate: 'YYYY-MM-DD'
              }}
              controlId={'to_date'}
              label={'To Date'}
              formik={formik}
              required
            />
          </InputBox>
        </Col>
      </Row>
    </CreateModal>
  );
};

export default CreateHolidays;
